// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__X9pPG","row":"Layout_row__e-Fnz","col":"Layout_col__e-iSe"};